module.exports = __webpack_public_path__ + "img/pop.89ec43fd.png";